module.exports = __webpack_public_path__ + "media/4x3/es-ga-2618e21f.svg";